module.exports = __webpack_public_path__ + "static/2-edc3bb163fbfa8ee94d873f9e57826b3.png";